import React from "react";

import Topbar from "Containers/Nav/Topbar";
import ListCLinicsBudgets from "Pages/Budgets/ClinicsBudgets";
import { CovenantsBudgets } from "Pages/Budgets/Covenants";
import { PrivateBudgets } from "Pages/Budgets/Private";
import { Reception } from "Pages/Budgets/Reception/index";
import { RevisionBudget } from "Pages/Budgets/RevisionBudget/index";
import { ViewBudget } from "Pages/Budgets/ViewDetails";
import ListCoupons from "Pages/Coupon/Index";
import Coupon from "Pages/Coupon/View";
import { OrderDashboard } from "Pages/Dashboard/Order";
import { ResultsDashboard } from "Pages/Dashboard/Results";
import { RNDSDashboard } from "Pages/Dashboard/RNDS";
import { HealthInsurance } from "Pages/HealthInsurance";
import { CreateHealthInsurance } from "Pages/HealthInsurance/CreateHealthInsurance";
import { EditHealthInsurance } from "Pages/HealthInsurance/EditHealthInsurance";
import { Chat } from "Pages/Chat";
import HomeOrdersTelemedicina from "Pages/HomeOrders/ExportTelemedicina";
import HomeOrdersToMotion from "Pages/HomeOrders/ExportToMotion";
import ProductLogs from "Pages/Logs/productLogs";
import ImportOrders from "Pages/Orders/Import";
import ListOrders from "Pages/Orders/Index";
import ListPlansOrders from "Pages/Orders/ListPlansOrders/Index";
import OrderToken from "Pages/Orders/Token";
import { ListPersons } from "Pages/Person";
import Person from "Pages/Person/Show";
import PersonForm from "Pages/Person/Token";
import { ViewOrder } from "Pages/Person/TokenTabs/ViewOrder";
import { PersonDuplicated } from "Pages/PersonDuplicated";
import { CreateNewProduct } from "Pages/Product/CreateProduct";
import { EditProduct } from "Pages/Product/EditProduct";
import ListProduct from "Pages/Product/Index";
import ProductRules from "Pages/ProductRules";
import ProductRulesList from "Pages/ProductRules/ProductRulesList";
import EditProductRules from "Pages/ProductRules/EditProductRules";
import { RegistrationCleaning } from "Pages/RegistrationCleaning";
import { RegistrationReview } from "Pages/RegistrationReview";
import ListRNDS from "Pages/RNDS/Index";
import { ClinicalSchedule } from "Pages/Schedules/ClinicalSchedule";
import FinishRegisterForm from "Pages/ServiceForm/LeadToPerson/index";
import ServiceFormOrderList from "Pages/ServiceForm/OrderList";
import ServiceFormPayment from "Pages/ServiceForm/Payment";
import PaymentFormsSelect from "Pages/ServiceForm/PaymentForms";
import ServiceFormResume from "Pages/ServiceForm/Resume";
import ServiceAttendanceType from "Pages/ServiceForm/SelectAttendance";
import ServiceFormSelectBudget from "Pages/ServiceForm/SelectBudgetType";
import ServiceFormPacient from "Pages/ServiceForm/SelectPacient";
import ServiceFormSelectProducts from "Pages/ServiceForm/SelectProducts";
import ServiceUnitSelect from "Pages/ServiceForm/SelectUnit";
import ListUsers from "Pages/Users/Index";
import Users from "Pages/Users/View";
import Partners from "Pages/Partners";
import ExportOrdersToMotion from "Pages/Orders/ExportToMotion";
import { LinkRemoto } from "Pages/LinkRemoto";

import Sidebar from "Components/Nav/Sidebar";

import { CreateOrderAttendance } from "Pages/Orders/CreateOrder/components/Collect";
import { CreateOrderIdentification } from "Pages/Orders/CreateOrder/components/Patient";
import { CreateOrderPayment } from "Pages/Orders/CreateOrder/components/Payment";
import { PaymentTypes } from "Pages/Orders/CreateOrder/components/PaymentTypes";
import ReportLog from "Pages/ReportLog";
import Schedule from "Pages/Schedule";
import MarSaudeImport from "Pages/HomeOrders/MarSaude";
import { CreatePartner } from "Pages/Partners/CreatePartner";
import { EditPartner } from "Pages/Partners/EditPartner";
import PartnerOrder from "Pages/PartnersOrders/Index";
import SchedulePartner from "Pages/SchedulePartner";
import PreOrderList from "Pages/PreBudgetList";
import ConvertPreOrder from "Pages/PreBudgetConvertion";
import ConvertPreOrderIA from "Pages/PreBudgetConvertionIA";
import { PreBudgetDetails } from "Pages/PreBudgetDetail";
import { ClientsBudgets } from "Pages/Budgets/Clients";
import ClientsBudgetService from "Pages/ClientBudgetService";
import ClientOrders from "Pages/Orders/ClientOrders/Index";
import Welcome from "Pages/Welcome";
import ClientsBudgetServiceUnit from "Pages/ClientBudgetServiceUnit";
import ConvertPreOrderIAUnit from "Pages/PreBudgetConvertionIAUnit";
import ConvertPreOrderUnit from "Pages/PreBudgetConvertionUnit";
import { PreBudgetDetailsUnit } from "Pages/PreBudgetDetailUnit";
import PreOrderListUnit from "Pages/PreBudgetListUnit";
import { ClientsBudgetsUnit } from "Pages/Budgets/ClientsUnit";
import PartnerOrdersUnit from "Pages/Orders/ClientOrdersUnit";
import { Result } from "Pages/Result";
import ExportUnitOrdersToMotion from "Pages/UnitOrderMotion/ExportToMotion";
import ImportPersons from "Pages/ImportPersons";
import { CreateUnit } from "Pages/Units/Create";
import { EditUnit } from "Pages/Units/Edit";
import { Units } from "Pages/Units/List";
import ConvertPrePreOrderIAUnit from "../../Pages/PreOrderConvertionIAUnit";
import PrePreOrderListUnit from "../../Pages/PreOrderListUnit";
import HomeOrders from "../../Pages/HomeOrders";
import LabiCredits from "../../Pages/LabiCredits";
import LabiWallet from "../../Pages/LabiCredits/LabiWallet";
import MyAccountLabiCredits from "../../Pages/LabiCredits/MyAccountLabiCredits";
import Salesforce from "../../Pages/Logs/Salesforce";
import { SendMotion } from "../../Pages/Orders/SendMotion";
import ListSchedule from "../../Pages/Schedules/Index";
import { UnitAvailability } from "../../Pages/Units/UnitsAvailability";
import { UnitsHolidayDetail } from "../../Pages/Units/UnitsHolidayDetail";
import { UnitsHolidayList } from "../../Pages/Units/UnitsHolidayList";
import { ListAlerts } from "../../Pages/Units/Alerts";
import { ListRegions } from "../../Pages/Units/Regions/Index";

export default [
  {
    component: ListPersons,
    path: "/pessoas",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Persons",
    footer: false,
    exact: true,
  },
  {
    component: ListPersons,
    path: "/clientes",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Persons",
    footer: false,
    exact: true,
  },
  {
    component: PersonDuplicated,
    path: "/pessoas-duplicadas",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Persons",
    footer: false,
    exact: true,
  },
  {
    component: Person,
    path: "/pessoa/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Persons", "Update Persons"],
    footer: false,
    exact: true,
  },
  {
    component: PersonForm,
    path: "/ficha-cliente/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Persons",
    footer: false,
    exact: true,
  },
  {
    component: ViewOrder,
    path: "/ficha-cliente/:personId/appointments/:orderId",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Persons",
    footer: false,
    exact: true,
  },

  {
    component: ListProduct,
    path: "/produtos",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Products",
    footer: false,
    exact: true,
  },
  {
    component: CreateNewProduct,
    path: "/produtos/novo",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Create Products",
    footer: false,
    exact: true,
  },
  {
    component: EditProduct,
    path: ["/produto/:productId/editar", "/produto/:duplicar/:productId"],
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Create Products",
    footer: false,
    exact: true,
  },
  {
    component: ProductLogs,
    path: "/log-produtos",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Create Products",
    footer: false,
    exact: true,
  },
  {
    component: ProductRulesList,
    path: "/regras/regras-produtos/lista",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Create Products",
    footer: false,
    exact: true,
  },
  {
    component: EditProductRules,
    path: "/regras/regras-produto/editar/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Create Products",
    footer: false,
    exact: true,
  },
  {
    component: ProductRules,
    path: "/regras/regras-produto",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Create Products",
    footer: false,
    exact: true,
  },

  {
    component: Units,
    path: "/unidades",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "List Units",
    footer: false,
    exact: true,
  },
  {
    component: CreateUnit,
    path: "/unidades/novo",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "List Units",
    footer: false,
    exact: true,
  },

  {
    component: UnitAvailability,
    path: "/unidades/disponibilidade/novo",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Units", "Update Units"],
    footer: false,
    exact: true,
  },
  {
    component: UnitAvailability,
    path: "/unidades/disponibilidade/:holidayId/editar",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Units", "Update Units"],
    footer: false,
    exact: true,
  },
  {
    component: UnitsHolidayDetail,
    path: "/unidades/disponibilidade/:holidayId",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Units", "Update Units"],
    footer: false,
    exact: true,
  },
  {
    component: UnitsHolidayList,
    path: "/unidades/disponibilidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Units", "Update Units"],
    footer: false,
    exact: true,
  },

  {
    component: EditUnit,
    path: "/unidades/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Units", "Update Units"],
    footer: false,
    exact: true,
  },
  {
    component: HealthInsurance,
    path: "/convenios",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Units", "Update Units"],
    footer: false,
    exact: true,
  },
  {
    component: CreateHealthInsurance,
    path: "/convenios/novo",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Units", "Update Units"],
    footer: false,
    exact: true,
  },
  {
    component: EditHealthInsurance,
    path: "/convenios/editar/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Units", "Update Units"],
    footer: false,
    exact: true,
  },

  {
    component: ListRegions,
    path: "/regioes",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Units", "Update Units"],
    footer: false,
    exact: true,
  },

  {
    component: ListAlerts,
    path: "/alertas",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Units", "Update Units"],
    footer: false,
    exact: true,
  },
  {
    component: ListOrders,
    path: "/pedidos",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Orders",
    footer: false,
    exact: true,
  },
  {
    component: LinkRemoto,
    path: "/checkout-remoto",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Orders",
    footer: false,
    exact: true,
  },

  {
    component: CreateOrderAttendance,
    path: "/pedidos/criar-pedido/coleta",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Orders",
    footer: false,
    exact: true,
  },
  {
    component: CreateOrderIdentification,
    path: "/pedidos/criar-pedido/identificacao",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Orders",
    footer: false,
    exact: true,
  },
  {
    component: CreateOrderPayment,
    path: "/pedidos/criar-pedido/pagamento",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Orders",
    footer: false,
    exact: true,
  },
  {
    component: PaymentTypes,
    path: "/pedidos/criar-pedido/tipo-pagamento",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Orders",
    footer: false,
    exact: true,
  },
  // {
  //   component: CreateOrder,
  //   path: "/pedidos/criar-pedido",
  //   header: <Topbar />,
  //   sidebar: <Sidebar />,
  //   permissions: "Consult Orders",
  //   footer: false,
  //   exact: true,
  // },
  {
    component: ListPlansOrders,
    path: "/pedidos-convenios",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Orders",
    footer: false,
    exact: true,
  },

  {
    component: HomeOrders,
    path: "/pedidos-domiciliar",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Send Orders to Motion",
    footer: false,
    exact: true,
  },
  {
    component: ImportOrders,
    path: "/pedidos/importar",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Import Orders",
    footer: false,
    exact: true,
  },

  {
    component: MarSaudeImport,
    path: "/pedidos/mar-saude",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Integrate MarSaude Motion",
    footer: false,
    exact: true,
  },
  {
    component: OrderToken,
    path: "/ficha-de-pedido/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Orders",
    footer: false,
    exact: true,
  },

  {
    component: SendMotion,
    path: "/pedidos-envio/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Send Orders to Motion",
    footer: false,
    exact: true,
  },
  {
    component: ListCoupons,
    path: "/cupons",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Coupons",
    footer: false,
    exact: true,
  },
  {
    component: Partners,
    path: "/parceiros",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: [
      "Atualizar Partner",
      "Cadastrar Partner",
      "Visualizar Partner",
      "Listar Partners",
    ],
    footer: false,
    exact: true,
  },
  {
    component: SchedulePartner,
    path: "/parceiro-agendamento",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: [
      "Listar Agendamento Partner",
      "Visualizar Agendamento Partner",
      "Cadastrar Agendamento Partner",
      "Atualizar Agendamento Partner",
    ],
    footer: false,
    exact: true,
  },
  {
    component: PartnerOrder,
    path: "/listar-agendamentos-parceiros",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: [
      "Listar Agendamento Partner",
      "Visualizar Agendamento Partner",
      "Cadastrar Agendamento Partner",
      "Atualizar Agendamento Partner",
    ],
    footer: false,
    exact: true,
  },
  {
    component: CreatePartner,
    path: "/criar-parceiro",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: [
      "Atualizar Partner",
      "Cadastrar Partner",
      "Visualizar Partner",
      "Listar Partners",
    ],
    footer: false,
    exact: true,
  },
  {
    component: EditPartner,
    path: "/editar-parceiro/:partnerId",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },
  {
    component: ReportLog,
    path: "/controle-visualizacao",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Coupons",
    footer: false,
    exact: true,
  },
  {
    component: Coupon,
    path: "/cupons/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Coupons", "Update Coupons"],
    footer: false,
    exact: true,
  },

  {
    component: PrivateBudgets,
    path: "/orcamentos/particular",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Budgets",
    footer: false,
    exact: true,
  },
  {
    component: CovenantsBudgets,
    path: "/orcamentos/convenio",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Budgets",
    footer: false,
    exact: true,
  },
  {
    component: ViewBudget,
    path: "/orcamento/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Budgets",
    footer: false,
    exact: true,
  },

  {
    component: ListCLinicsBudgets,
    path: "/orcamentos/clinicas",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Budgets",
    footer: false,
    exact: true,
  },

  {
    component: Reception,
    path: "/orcamento/pre-acolhimento/:person_type/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Budgets",
    footer: false,
    exact: true,
  },

  {
    component: RegistrationCleaning,
    path: "/limpeza-cadastro/:document/:step",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Edit Persons",
    footer: false,
    exact: true,
  },

  {
    component: ListSchedule,
    path: "/agendamentos",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: [
      "List Appointments",
      "Show Appointments Calendars",
      "Show Appointments Historic",
      "List Date and Time for Appointments",
      "Reschedule Appointments",
      "Cancel Appointments",
      "Update Appointment",
    ],
    footer: false,
    exact: true,
  },

  {
    component: LabiCredits,
    path: "/labi-creditos",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "List Wallet Credits and Movimentations",
    footer: false,
    exact: true,
  },

  {
    component: LabiWallet,
    path: "/labi-creditos/minha-conta",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "List Wallet Credits and Movimentations",
    footer: false,
    exact: true,
  },

  {
    component: MyAccountLabiCredits,
    path: "/labi-creditos/minha-conta/:userID",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "List Wallet Credits and Movimentations",
    footer: false,
    exact: true,
  },

  {
    component: ServiceFormPacient,
    path: "/ficha-de-atendimento/paciente",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },
  {
    component: ServiceAttendanceType,
    path: "/ficha-de-atendimento/:person_type/tipo-de-atendimento",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },
  {
    component: ServiceFormSelectBudget,
    path: "/ficha-de-atendimento/:person_type/tipo-de-orcamento",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },
  {
    component: ServiceFormOrderList,
    path: "/ficha-de-atendimento/:type/orcamentos",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },
  {
    component: ServiceFormSelectProducts,
    path: [
      "/ficha-de-atendimento/:person_type/selecionar-produtos/:budget_id",
      "/ficha-de-atendimento/:person_type/selecionar-produtos",
    ],
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },
  {
    component: ServiceUnitSelect,
    path: "/ficha-de-atendimento/:person_type/:budget_id/selecionar-unidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },

  {
    component: FinishRegisterForm,
    path: "/ficha-de-atendimento/finalizar-cadastro/:budget_id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },

  {
    component: ServiceFormResume,
    path: "/ficha-de-atendimento/resumo/:budget_id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Budgets",
    footer: false,
    exact: true,
  },
  {
    component: ServiceFormPayment,
    path: "/ficha-de-atendimento/pagamento/:budget_id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },

  {
    component: ListUsers,
    path: "/usuarios",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Users",
    footer: false,
    exact: true,
  },
  {
    component: Users,
    path: "/usuarios/:id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Users", "Update Users"],
    footer: false,
    exact: true,
  },
  {
    component: RegistrationReview,
    path: "/revisao/usuario",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Users", "Update Users"],
    footer: false,
    exact: true,
  },

  {
    component: ListRNDS,
    path: "/rnds",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult RNDS",
    footer: false,
    exact: true,
  },

  {
    component: Salesforce,
    path: "/salesforce",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult RNDS",
    footer: false,
    exact: true,
  },

  {
    component: OrderDashboard,
    path: "/dashboard/pedidos",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult RNDS",
    footer: false,
    exact: true,
  },

  {
    component: RNDSDashboard,
    path: "/dashboard/rnds",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult RNDS",
    footer: false,
    exact: true,
  },
  {
    component: ResultsDashboard,
    path: "/dashboard/resultados",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult RNDS",
    footer: false,
    exact: true,
  },
  {
    component: Schedule,
    path: "/consultar-agendas",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets", "Consult Appointment"],
    footer: false,
    exact: true,
  },
  {
    component: PaymentFormsSelect,
    path: "/ficha-de-atendimento/clinicas/pagamento/:budget_id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },
  {
    component: RevisionBudget,
    path: "/pedido/revisar/:order_id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },
  {
    component: ClinicalSchedule,
    path: "/pedido/agendar/:order_id",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Create Budgets", "Update Budgets"],
    footer: false,
    exact: true,
  },
  {
    component: OrderDashboard,
    path: "/dashboard/orders",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult RNDS",
    footer: false,
    exact: true,
  },

  {
    component: RNDSDashboard,
    path: "/dashboard/laudos",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult RNDS",
    footer: false,
    exact: true,
  },
  {
    component: ResultsDashboard,
    path: "/dashboard/results",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult RNDS",
    footer: false,
    exact: true,
  },

  {
    component: HomeOrdersTelemedicina,
    path: "/pedidos/telemedicina",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Send Orders to Motion",
    footer: false,
    exact: true,
  },
  // INICIO ROTAS PARCEIRO DOMICILIAR
  {
    component: PreOrderList,
    path: "/listagem-pre-orcamento/domiciliar",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Listar pre-budgets"],
    footer: false,
    exact: true,
  },
  {
    component: ConvertPreOrder,
    path: "/converter-pre-orcamento/:id/domiciliar",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Atualizar pre-budget"],
    footer: false,
    exact: true,
  },
  {
    component: ConvertPreOrderIA,
    path: "/converter-pre-orcamento-ia/:id/domiciliar",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Atualizar pre-budget"],
    footer: false,
    exact: true,
  },
  {
    component: PreBudgetDetails,
    path: [
      "/detalhes-pre-orcamento/:id/domiciliar",
      "/detalhes-pre-orcamento/domiciliar",
    ],
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Visualizar pre-budget",
    footer: false,
    exact: true,
  },
  {
    component: ClientsBudgets,
    path: "/orcamentos/parceiro/domiciliar",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Listar budgets",
    footer: false,
    exact: true,
  },
  {
    component: ClientsBudgetService,
    path: "/ficha-de-atendimento-parceiro/:id/domiciliar",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Visualizar budget",
    footer: false,
    exact: true,
  },
  {
    component: ClientOrders,
    path: "/parceiro/pedido/domiciliar",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Orders",
    footer: false,
    exact: true,
  },
  {
    component: HomeOrdersToMotion,
    path: "/pedido-domiciliar/motion/domiciliar",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Send Orders to Motion",
    footer: false,
    exact: true,
  },
  {
    component: ExportOrdersToMotion,
    path: "/pedidos/importacao-lote",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Send Orders to Motion",
    footer: false,
    exact: true,
  },
  {
    component: Welcome,
    path: "/boas-vindas",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Bem vindo"],
    footer: false,
    exact: true,
  },
  {
    component: PreOrderListUnit,
    path: "/listagem-pre-orcamento/unidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Listar budgets unit", "Listar pre-budgets unit"],
    footer: false,
    exact: true,
  },
  {
    component: ConvertPreOrderUnit,
    path: "/converter-pre-orcamento/:id/unidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Listar budgets unit", "Listar pre-budgets unit"],
    footer: false,
    exact: true,
  },
  {
    component: ConvertPreOrderIAUnit,
    path: "/converter-pre-orcamento-ia/:id/unidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Listar budgets unit", "Listar pre-budgets unit"],
    footer: false,
    exact: true,
  },
  {
    component: PreBudgetDetailsUnit,
    path: [
      "/detalhes-pre-orcamento/:id/unidade",
      "/detalhes-pre-orcamento/unidade",
    ],
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Listar budgets unit", "Listar pre-budgets unit"],
    footer: false,
    exact: true,
  },
  {
    component: ClientsBudgetsUnit,
    path: "/orcamentos/parceiro/unidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Listar budgets unit", "Listar pre-budgets unit"],
    footer: false,
    exact: true,
  },
  {
    component: ClientsBudgetServiceUnit,
    path: "/ficha-de-atendimento-parceiro/:id/unidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Listar budgets unit", "Listar pre-budgets unit"],
    footer: false,
    exact: true,
  },
  {
    component: PartnerOrdersUnit,
    path: "/parceiro/pedido/unidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Listar budgets unit", "Listar pre-budgets unit"],
    footer: false,
    exact: true,
  },
  {
    component: ExportUnitOrdersToMotion,
    path: "/pedido-unidade/motion/unidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: ["Listar budgets unit", "Listar pre-budgets unit"],
    footer: false,
    exact: true,
  },
  {
    component: Result,
    path: "/resultados",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Listar budgets",
    footer: false,
    exact: true,
  },
  {
    component: ImportPersons,
    path: "/importacao-pessoas",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Consult Persons",
    footer: false,
    exact: true,
  },
  {
    component: PrePreOrderListUnit,
    path: "/pre-pedido-unidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: [
      "Listar cli pre-orders",
      "Visualizar cli pre-orders",
      "Atualizar cli pre-orders",
      "Cancelar cli pre-orders",
      "Enviar cli pre-orders Motion",
    ],
    footer: false,
    exact: true,
  },
  {
    component: ConvertPrePreOrderIAUnit,
    path: "/converter-pre-pedido-ia/:id/unidade",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: [
      "Listar cli pre-orders",
      "Visualizar cli pre-orders",
      "Atualizar cli pre-orders",
      "Cancelar cli pre-orders",
      "Enviar cli pre-orders Motion",
    ],
    footer: false,
    exact: true,
  },
  {
    component: Chat,
    path: "/chat",
    header: <Topbar />,
    sidebar: <Sidebar />,
    permissions: "Visualizar Chat ia",
    footer: false,
    exact: true,
  },
];
